import axios from "axios";

const publicApi = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

const wrap = (promise) =>
  promise
    .then((r) => ({ status: r.status, data: r.data }))
    .catch((err) => ({
      status: err.response?.status || 500,
      data: err.response?.data || null,
      message: err.response?.data?.message || err.message || "Request failed",
    }));

export const getSessionByToken = (token) =>
  wrap(publicApi.get(`/public/session-link/${token}`));

export const registerViaLink = (token, payload) =>
  wrap(publicApi.post(`/public/session-link/${token}/register`, payload));

export const requestOtp = (token, email) =>
  wrap(publicApi.post(`/public/session-link/${token}/request-otp`, { email }));

export const verifyOtp = (token, email, otp) =>
  wrap(publicApi.post(`/public/session-link/${token}/verify-otp`, { email, otp }));
